import "@fontsource/heebo/100.css";
import "@fontsource/heebo/200.css";
import "@fontsource/heebo/300.css";
import "@fontsource/heebo/400.css";
import "@fontsource/heebo/500.css";
import "@fontsource/heebo/600.css";
import "@fontsource/heebo/700.css";
import "@fontsource/heebo/800.css";
import "@fontsource/heebo/800.css";

document.addEventListener( 'splideReady', function( e ) {
    e.detail.defaults = {
        arrowPath: 'M0.716732 40.2378C0.413549 39.9525 0.253045 39.578 0.253045 39.1857C0.253045 38.8469 0.377881 38.4903 0.627561 38.2228L16.8032 20.6234L0.627561 3.00613C0.0925326 2.4177 0.128201 1.52615 0.716732 0.99121C1.30526 0.456273 2.19697 0.49194 2.732 1.06254L19.8707 19.6427C20.3701 20.1955 20.3701 21.0335 19.8707 21.5863L2.732 40.1664C2.19697 40.7192 1.28743 40.7727 0.716732 40.2378Z',
    };
} );

export default {
}
